/* eslint-disable react/jsx-no-target-blank */
import { COLORS, TYPOGRAPHY } from '@app/constants';
import { BreakpointsEnum } from '@app/types';
import { FC } from 'react';
import styled from 'styled-components';
import { EmailForm } from './components';
import { UserResponseDtoRoleEnum } from '@app/api';
import { getSignUpDataByRole, getTitleByRole } from './helpers';
import NavLink from '@app/ui/components/NavLink';
import { RoutesPath } from '@/app/routers';
import { useRouter } from 'next/router';

interface Props {
  role: UserResponseDtoRoleEnum;
}

const ChooseWay: FC<Props> = ({ role }) => {
  const router = useRouter();
  const query = router.query;
  const onlyRegistration = query.onlyRegistration === 'true';
  const signUpData = getSignUpDataByRole(role);

  const loginHref = (onlyRegistration ? '/login?onlyRegistration=true' : '/login') as RoutesPath;

  const offerByRole =
    role === UserResponseDtoRoleEnum.Therapist
      ? '/documents/public-offer-expert.pdf'
      : '/documents/public-offer-user.pdf';

  return (
    <Wrapper>
      <Title>{getTitleByRole(role)}</Title>
      <HeadWrapper>
        <HasAccount>
          Уже есть аккаунт?
          <StyledNavLink to={loginHref}>Войти</StyledNavLink>
        </HasAccount>

        {!onlyRegistration && (
          <StyledNavLink to={signUpData.href}>{signUpData.text}</StyledNavLink>
        )}
      </HeadWrapper>
      <FormWrapper>
        <EmailForm role={role} />
      </FormWrapper>
      <PoliciesText>
        Нажимая “Создать аккаунт”, вы соглашаетесь с{' '}
        <a href="/documents/privacy-policy.pdf" target="_blank">
          политикой конфиденциальности
        </a>{' '}
        и{' '}
        <a href={offerByRole} target="_blank">
          условиями использования
        </a>
      </PoliciesText>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media (min-width: ${BreakpointsEnum.s}px) {
    padding: 40px 32px 48px 32px;
  }
  @media (max-width: ${BreakpointsEnum.s}px) {
    padding: 24px 16px 40px 16px;
  }
`;

const Title = styled.h2`
  ${TYPOGRAPHY.heading3Bold24};
  color: ${COLORS.grayscale700};
  margin-bottom: 8px;
`;

const HeadWrapper = styled.div`
  @media (min-width: ${BreakpointsEnum.s}px) {
    margin-bottom: 40px;
  }
  @media (max-width: ${BreakpointsEnum.s}px) {
    margin-bottom: 32px;
  }
`;

const HasAccount = styled.p`
  ${TYPOGRAPHY.body1Regular14};
  color: ${COLORS.grayscale600};
  margin-bottom: 12px;
  a {
    font-weight: bold;
    color: ${COLORS.primary300};
    margin-left: 4px;
  }
`;

const FormWrapper = styled.div`
  margin-bottom: 16px;
`;

const PoliciesText = styled.p`
  ${TYPOGRAPHY.disclaimerRegular12};
  color: ${COLORS.grayscale500};
  a {
    font-weight: 500;
    text-decoration: underline;
    color: ${COLORS.primary400};
  }
`;

const StyledNavLink = styled(NavLink)`
  &[data-current='false'] {
    color: ${COLORS.primary300};
  }
  &:hover {
    color: ${COLORS.primary400};
  }
`;

export default ChooseWay;
